import React, { memo } from 'react';

import { ListItemSecondaryAction, ListSubheader } from '../material-ui/List';
import { AirportServiceListItem } from './AirportServiceListItem/AirportServiceListItem';
import { Landing, Takeoff } from '../../icons';

export const AirportServiceSection = memo(({ index, isTakeOff, title, services, legId, allowEdit, allowDelete, classes }) => {
    return (
        <li key={`section-${index}`}>
            <ul className={classes.ul}>
                <ListSubheader className={classes.airport}>
                    {title}
                    <ListItemSecondaryAction className={classes.menu}>
                        {isTakeOff ? <Takeoff width="24" height="24" /> : <Landing width="24" height="24" />}
                    </ListItemSecondaryAction>
                </ListSubheader>
                {services.map((item) => (
                    <AirportServiceListItem key={item.id} legId={legId} service={item} allowEdit={allowEdit} allowDelete={allowDelete} />
                ))}
            </ul>
        </li>
    );
});
